import { RevenueFilter, TopPerformersFilter } from 'common/models/Reporting/AnalyticsFilterData';
import { TopPerformersRecord } from 'common/models/Reporting/BusinessIntelligence';
import { ForecastGraphData } from 'common/models/Reporting/Forecasts';
import { Revenue, RevenueTrend } from 'common/models/Reporting/Revenue';
import { ErrorHandler, RequestOptions } from 'common/models/GenericTypes';
import { Post } from 'util/HttpUtils';

export async function GetRevenueDataForGraph(
  filterData: RevenueFilter,
  kioskToken?: string | null,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
  };
  let url = 'api/Reporting/RevenueGraphData';
  if (kioskToken) {
    url = `api/DashboardKiosks/${kioskToken}/RevenueGraphData`;
  }

  return Post<Revenue>(url, options, filterData);
}

export async function GetRevenueTrendDataForGraph(
  filterData: RevenueFilter,
  kioskToken: string | null,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
  };

  let url = 'api/Reporting/RevenueTrend';

  if (kioskToken) {
    url = `api/DashboardKiosks/${kioskToken}/RevenueTrend`;
  }

  return Post<RevenueTrend[]>(url, options, filterData);
}

export async function CustomTopPerformers(
  filterData: TopPerformersFilter,
  kioskToken: string | null,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
  };

  let url = 'api/Reporting/CustomTopPerformers';
  if (kioskToken) {
    url = `api/DashboardKiosks/${kioskToken}/CustomTopPerformers`;
  }

  return Post<TopPerformersRecord[]>(url, options, filterData);
}

export async function GetForecastDataForGraph(
  filterData: RevenueFilter,
  kioskToken: string | null,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    errorHandler,
  };

  let url = 'api/Reporting/ForecastGraphData';
  if (kioskToken) {
    url = `api/DashboardKiosks/${kioskToken}/ForecastGraphData`;
  }

  return Post<ForecastGraphData>(url, options, filterData);
}
